exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".store-filter-item{cursor:pointer;padding:14px 16px;transition:background-color .2s ease;display:flex;align-items:center}.store-filter-item:hover{background-color:#f8f8f8}.store-filter-item.selected,.store-filter-item.selected:hover{background-color:#163b50}.store-filter-item.selected .icon-inverted{color:#fff}", ""]);

// exports
